/**
 * Model to hold Permission data from identity
 */
import { IdentityUser } from '@reg/shared/model';

export class IdentityPermission {
    public static ACTION_MODIFY: string = 'modify';
    public static RESOURCE_TYPE_TEAM: string = 'team';
    public static RESOURCE_TYPE_ORGANIZATION: string = 'organization';
    public static RESOURCE_TYPE_ASSESSOR: string = 'assessor';

    public id: string = null;
    public role: string = null;
    public resourceType: string = null;
    public resourceId: string = null;
    public user: IdentityUser = null;
    public action: string = null;

    public clone(): IdentityPermission {
        const clone: IdentityPermission = new IdentityPermission();
        clone.id = this.id;
        clone.role = this.role;
        clone.resourceType = this.resourceType;
        clone.resourceId = this.resourceId;
        clone.action = this.action;
        clone.user = this.user && this.user.clone();

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'permission';
        json.data.id = this.id;
        json.data.attributes = {};

        if (this.id) {
            // Update permission
            json.data.attributes.action = this.action;
        } else {
            // Create permission
            json.data.attributes.userId = this.user.id;
            json.data.attributes.action = this.action;
            json.data.attributes.resourceType = this.resourceType;
            json.data.attributes.resourceId = this.resourceId;
        }

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: any, included: any[] = null): IdentityPermission {
        const data: any = json['data'] || json;
        const attrs: any = data.attributes || [];
        included = included || json['included'] || [];

        this.id = data.id;
        this.role = attrs.role;
        this.resourceType = attrs.resourceType;
        this.resourceId = attrs.resourceId;
        this.action = attrs.action;

        // Fill user from relationships if it exists
        const user: any = included.filter((i: any) => i['type'] === 'user' && i['id'] === attrs.userId)[0];

        if (user) {
            this.user = (new IdentityUser(attrs.userId)).deserialize(user, included);
        } else {
            this.user = new IdentityUser(attrs.userId);
        }

        return this;
    }
}
